var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatePicker = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H3V2H2L2 0Z",
    fill: "#606A76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H4V2H8V1Z",
    fill: "#606A76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H1V1H0V12H12V1H11V11Z",
    fill: "#606A76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H9V2H10V0Z",
    fill: "#606A76"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatePicker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/datePicker.40b550b2913594ed79273be02dfa294b.svg";